
import store from '@/store';
import { defineComponent } from 'vue';
import { GlobalPagination } from '@/interfaces/panel/global-pagination.model';
import ButtonComponent from '@/components/appComponents/Button.vue';
import IpgTransactionSkelton from '@/components/transactionsComponents/IpgTransactionSkelton.vue';
import WithdrawalsTableComponent from '@/components/transactionsComponents/WithdrawalsTable.vue';
import CustomPaginationComponent from '@/components/appComponents/CustomPagination.vue';
import router from '@/router';

export default defineComponent({
    name: "UserWithdrawalsPage",

    components: { ButtonComponent, IpgTransactionSkelton, WithdrawalsTableComponent, CustomPaginationComponent },

    data() {
        return {
            user: ""
        }
    },

    computed: {
        getLoadingPanel(): boolean {
            return store.getters["panel/getLoadingPanel"];
        },

        getAllWithdrawals() {
            return store.getters["panel/getUserWithdrawals"];
        },

        getGlobalPagination(): GlobalPagination {
            return store.getters["panel/getGlobalPagination"];
        }
    },

    methods: {
        back(): void {
            router.push({ name: "Users" });
        },

        handelPagination() {
            const query = this.$route.query;
            store.dispatch("panel/getUserWithdrawalsRequest", query.user);
        },

    },

    mounted() {
        const query = this.$route.query;
        store.dispatch("panel/getUserWithdrawalsRequest", query.user);
    }
})
